// abstract-solana/src/env/solana.ts
import * as D from "../imports/index.js";
import { getEnvValue } from "@putkoff/abstract-env";

export function loadSolanaEnv() {
  return {
    solanaMainnetRpcUrl:
      process.env.SOLCATCHER_SOLANA_MAINNETRPC_URL ??
      getEnvValue({ key: "SOLCATCHER_SOLANA_MAINNETRPC_URL" }) ??
      getEnvValue({ key: "SOLANA_MAINNETRPC_URL" }) ??
      D.SOLANA_MAINNET_RPC_URL,

    solanaMainnetWsEndpoint:
      process.env.SOLCATCHER_SOLANA_MAINNET_WS_ENDPOINT ??
      getEnvValue({ key: "SOLCATCHER_SOLANA_MAINNET_WS_ENDPOINT" }) ??
      getEnvValue({ key: "SOLANA_MAINNET_WS_ENDPOINT" }) ??
      D.SOLANA_MAINNET_WS_ENDPOINT,

    fallbackRpcUrl:
      process.env.SOLCATCHER_SOLANA_FALLBACK_RPC_URL ??
      getEnvValue({ key: "SOLCATCHER_SOLANA_FALLBACK_RPC_URL" }) ??
      getEnvValue({ key: "SOLANA_FALLBACK_RPC_URL" }) ??
      D.SOLANA_FALLBACK_RPC_URL,

    fallbackWsEndpoint:
      process.env.SOLCATCHER_SOLANA_FALLBACK_WS_ENDPOINT ??
      getEnvValue({ key: "SOLCATCHER_SOLANA_FALLBACK_WS_ENDPOINT" }) ??
      getEnvValue({ key: "SOLANA_FALLBACK_WS_ENDPOINT" }) ??
      D.SOLANA_FALLBACK_WS_ENDPOINT
  };
}

